<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ReservationForm :baseReservation="reservation" :basereservationName="name" :loading="loading" @submit-requested="submitRequested"></ReservationForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ReservationForm from './ReservationForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                reservation: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { ReservationForm },
        computed:
        {
            ...mapState('reservations', ['getReservationByIdOutput']),
        },
        methods: {
            ...mapActions('reservations', ['getReservationById']),
            ...mapActions('reservations', ['putReservation']),
            submitRequested(reservation) {
                this.putReservation(reservation);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: 'Reservations'});
            }
            else {
                this.getReservationById(this.$route.query.id);
            }
        },
        watch:
        {
            getReservationByIdOutput: function (output) {
                if (!output) {
                    router.push({name: 'Reservations'});
                }
                else {
                    this.reservation = output;
                    this.loading = false;
                }
            }
        }
    }
</script>